import { type OfferV11 } from '@redteclab/api/clients/bully'

import { type OfferV1OfferPromotionPromotionType } from '../OfferV1OfferPromotionPromotionType'

import { productAccessorIsSaeOffer } from './productAccessorIsSaeOffer'

export const productAccessorGetOfferPromotionType = (
  offer: OfferV11,
): OfferV1OfferPromotionPromotionType | undefined => {
  if (!productAccessorIsSaeOffer(offer)) {
    return undefined
  }

  const promotionType = offer.offerPromotion?.promotionType as
    | OfferV1OfferPromotionPromotionType
    | undefined

  return promotionType ?? undefined
}
